<template>
    <div v-if="$root.isMobile" class="mobile-page-title">
        <div class="d-flex justify-content-between align-items-center">
            <button type="button" class="btn btn-primary btn-sm" @click="showFilters = true">
                <i class="fal fa-sliders-h"></i> Filtri
            </button>
            <h4 class="mb-0 font-weight-bold flex-grow-1 text-center">
                Contratti
            </h4>
            <div style="width: 80px;"></div>
        </div>
    </div>
    <div class="kt-portlet__head">
        <form v-if="!$root.isMobile" class="isprint-filter" autocomplete="off"
            :style="{ marginBottom: $root.isTablet ? '100px' : '' }">
            <div class="form-group">
                <label>Agente</label><br>
                <input class="form-control form-control-sm" autocomplete="off" name="adasd" placeholder="Agente"
                    type="text" style="width:150px" v-model="search.DESCRIZIONE_AGENTE.VALUE">
            </div>
            <div class="form-group">
                <label>Tipologia Contratto</label><br>
                <select class="form-control form-control-sm" style="width: 150px;" v-model="search.FK_ID_TIPO.VALUE">
                    <option value="">Luce / Gas</option>
                    <option value="1">Luce</option>
                    <option value="2">Gas</option>
                </select>
            </div>
            <div class="form-group">
                <label>Cliente</label><br>
                <input class="form-control form-control-sm" autocomplete="off" name="adasd" placeholder="Denominazione"
                    type="text" style="width:150px" v-model="search.DENOMINAZIONE.VALUE">
            </div>
            <div class="form-group ">
                <label>Data Inizio Fornitura</label><br>
                <DatePicker placeholder="data" autocomplete="off" :dim="'sm'" type="text" style="width:150px"
                    v-model="search.DATA_INIZIO_FORNITURA.VALUE_FROM">
                </DatePicker>
            </div>
            <div class="form-group ">
                <label>Data Fine Fornitura</label><br>
                <DatePicker placeholder="data" autocomplete="off" :dim="'sm'" type="text" style="width:150px"
                    v-model="search.DATA_FINE_FORNITURA.VALUE_TO">
                </DatePicker>
            </div>
            <div class="form-group">
                <label>POD</label><br>
                <input class="form-control form-control-sm" autocomplete="off" name="adasd" placeholder="POD"
                    type="text" style="width:150px" v-model="search.POD.VALUE">
            </div>
            <div class="form-group">
                <label>PDR</label><br>
                <input class="form-control form-control-sm" autocomplete="off" name="adasd" placeholder="PDR"
                    type="text" style="width:150px" v-model="search.PDR.VALUE">
            </div>
            <div class="form-group">
                <label>Stato</label><br>
                <select class="form-control form-control-sm" style="width: 150px;" v-model="search.FLG_ATTIVO.VALUE">
                    <option value="">Tutti</option>
                    <option value="1">Attivo</option>
                    <option value="2">Chiuso da fatturare</option>
                    <option value="3">Attivo da fatturare</option>
                    <option value="4">In attivazione</option>
                    <option value="5">Disattivo</option>
                </select>
            </div>
            <div class="form-group">
                <label>Stato Liquidazione</label><br>
                <select class="form-control form-control-sm" style="width: 150px;" v-model="search.STATO_LIQUIDAZIONE.VALUE">
                    <option value="">Tutti</option>
                    <option value="liquidato">Liquidato</option>
                    <option value="in_scadenza">In scadenza</option>
                    <option value="mai_liquidato">Mai liquidato</option>
                    <option value="da_liquidare">Da liquidare</option>
                </select>
            </div>
            <div class="form-group">
                <label>Data Elaborazione</label><br>
                <DatePicker placeholder="data" autocomplete="off" :dim="'sm'" type="text" style="width:150px"
                    v-model="search.DATA_ELABORAZIONE.VALUE">
                </DatePicker>
            </div>
        </form>
        <div v-if="$root.isMobile">

            <div class="offcanvas-backdrop" :class="{ show: showFilters }" @click.self="showFilters = false">
                <aside class="offcanvas-panel" :class="{ open: showFilters }" role="dialog" aria-modal="true">
                    <div class="offcanvas-header" style="background: linear-gradient(135deg, #808000, #D9CB34);">
                        <h6 class="mb-0 text-light"><i class="fal fa-filter"></i> Filtri ricerca</h6>
                        <button type="button" class="btn btn-light btn-sm" @click="showFilters = false">
                            <i class="fal fa-times"></i>
                        </button>
                    </div>
                    <div class="offcanvas-body">
                        <form class="isprint-filter" autocomplete="off"
                            :style="{ marginBottom: $root.isTablet ? '100px' : '' }">
                            <div class="form-group">
                                <label>Agente</label><br>
                                <input class="form-control form-control-sm" autocomplete="off" name="adasd"
                                    placeholder="Agente" type="text" style="width:290px"
                                    v-model="search.DESCRIZIONE_AGENTE.VALUE">
                            </div>
                            <div class="form-group">
                                <label>Tipologia Contratto</label><br>
                                <select class="form-control form-control-sm" style="width: 290px;"
                                    v-model="search.FK_ID_TIPO.VALUE">
                                    <option value="">Luce / Gas</option>
                                    <option value="1">Luce</option>
                                    <option value="2">Gas</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Stato</label><br>
                                <select class="form-control form-control-sm" style="width: 140px;"
                                    v-model="search.FLG_ATTIVO.VALUE">
                                    <option value="">Tutti</option>
                                    <option value="1">Attivo</option>
                                    <option value="2">Chiuso da fatturare</option>
                                    <option value="3">Attivo da fatturare</option>
                                    <option value="4">In attivazione</option>
                                    <option value="5">Disattivo</option>
                                </select>
                            </div>
                             <div class="form-group">
                                <label>Stato Liquidazione</label><br>
                                <select class="form-control form-control-sm" style="width: 140px;"
                                    v-model="search.STATO_LIQUIDAZIONE.VALUE">
                                    <option value="">Tutti</option>
                                    <option value="liquidato">Liquidato</option>
                                    <option value="in_scadenza">In scadenza</option>
                                    <option value="mai_liquidato">Mai liquidato</option>
                                    <option value="da_liquidare">Da liquidare</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Data Elaborazione</label><br>
                                <DatePicker placeholder="data" autocomplete="off" :dim="'sm'" type="text" style="width:140px"
                                    v-model="search.DATA_ELABORAZIONE.VALUE">
                                </DatePicker>
                            </div>
                            <div class="form-group">
                                <label>Cliente</label><br>
                                <input class="form-control form-control-sm" autocomplete="off" name="adasd"
                                    placeholder="Denominazione" type="text" style="width:290px"
                                    v-model="search.DENOMINAZIONE.VALUE">
                            </div>
                            <div style="display: flex; gap: 10px;">
                                <div class="form-group">
                                    <label>Data Inizio</label><br>
                                    <DatePicker placeholder="data" autocomplete="off" :dim="'sm'" type="text" style="width:140px"
                                        v-model="search.DATA_INIZIO_FORNITURA.VALUE_FROM">
                                    </DatePicker>
                                </div>
                                <div class="form-group">
                                    <label>Data Fine</label><br>
                                    <DatePicker placeholder="data" autocomplete="off" :dim="'sm'" type="text" style="width:140px"
                                        v-model="search.DATA_FINE_FORNITURA.VALUE_TO">
                                    </DatePicker>
                                </div>
                            </div>
                            <div class="form-group">
                                <label>POD</label><br>
                                <input class="form-control form-control-sm" autocomplete="off" name="adasd"
                                    placeholder="POD" type="text" style="width:290px"
                                    v-model="search.POD.VALUE">
                            </div>
                            <div class="form-group">
                                <label>PDR</label><br>
                                <input class="form-control form-control-sm" autocomplete="off" name="adasd"
                                    placeholder="PDR" type="text" style="width:290px"
                                    v-model="search.PDR.VALUE">
                            </div>
                         
                           

                        </form>
                    </div>
                </aside>
            </div>
        </div>
    </div>
    <div class="isprint-grid-container">
        <table v-if="!$root.isMobile" class="isprint-grid shadow">
            <thead class="isprint-grid-thead">
                <tr style="left:0px;background: linear-gradient(135deg, #808000, #D9CB34);color:#fff">
                    <th style="width:8%"><span>Codice Contratto</span></th>
                    <th style="width:20%"><span>Agente</span></th>
                    <th style="width:22%"><span>Cliente</span></th>
                    <th style="width:12%"><span>Data Inizio Fornitura</span></th>
                    <th style="width:12%"><span>Data Fine Fornitura</span></th>
                    <th style="width:7%"><span>Stato</span></th>
                    <th style="width:13%"><span>Stato Liquidazione</span></th>
                    <th style="width:6%"><span>Azioni</span></th>
                </tr>
            </thead>
            <tbody class="isprint-grid-tbody" style="font-size:14px !important">
                <tr style="left: 0px; height: 50px" v-for="contratto in paginatedList.arr"
                    v-bind:key="contratto.ID_CONTRATTO">
                    <td style="width:8%">
                        <span v-if="contratto" class="badge bg-info text-white">
                            {{ contratto.CODICE_CONTRATTO }}
                        </span>
                    </td>
                    <td style="width:20%">
                        <span style="margin-right: 8px">
                            <i class="fad fa-user-secret mt-2" style="font-size: 20px;"></i>
                        </span>
                        <strong>{{ contratto.DESCRIZIONE_AGENTE || 'Nessun Agente' }}</strong><br>
                        <small>Gettone: {{ contratto.GETTONE_CONTRATTO }} €</small>
                    </td>
                    <td style="width:22%">
                        <div class="row">
                            <div class="col-1 d-flex justify-content-center align-items-center">
                                <i v-if="(contratto.POD).length > 1" class="fas fa-lightbulb text-warning"
                                    style="font-size: 20px;"></i>
                                <i v-else-if="(contratto.PDR).length > 1" class="fas fa-gas-pump text-danger"
                                    style="font-size: 20px;"></i>
                            </div>
                            <div class="col-11">
                                <strong>{{ contratto.DENOMINAZIONE || '' }}</strong><br>
                                <span v-if="(contratto.POD).length > 1" style="margin-right: 8px; display: block;">
                                    <strong>POD: </strong>{{ contratto.POD }}
                                </span>
                                <span v-else-if="(contratto.PDR).length > 1" style="margin-right: 8px; display: block;">
                                    <strong>PDR: </strong>{{ contratto.PDR }}
                                </span>
                            </div>
                        </div>
                    </td>

                    <td style="width:12%">
                        <i v-show="filters.formatDate(contratto.DATA_INIZIO_FORNITURA) != '01/01/1901'"
                            class="fad fa-calendar"></i>
                        {{ contratto.DATA_INIZIO_FORNITURA == '0000-00-00'  ? '—' :
                            filters.formatDate(contratto.DATA_INIZIO_FORNITURA) }}
                        {{ contratto.DATA_ELABORAZIONE == '0000-00-00'  ? '—' :
                            filters.formatDate(contratto.DATA_ELABORAZIONE) }}
                    </td>
                    <td style="width:12%">
                        <i v-show="contratto.DATA_FINE_FORNITURA != null && contratto.DATA_FINE_FORNITURA != '0000-00-00'"
                            class="fad fa-calendar"></i>
                        {{ (contratto.DATA_FINE_FORNITURA == null || contratto.DATA_FINE_FORNITURA == '0000-00-00') ? '—' :filters.formatDate(contratto.DATA_FINE_FORNITURA) }}
                    </td>
                    <td style="width:7%" class="text-center">
                        <span :class="getStatoBadgeClass(contratto.FLG_ATTIVO)">
                            {{ getStatoLabel(contratto.FLG_ATTIVO) }}
                        </span>
                    </td>
                    <td style="width:13%" class="text-center">
                        <!-- Solo POD - ciclo ricorrente -->
                        <span v-if="contratto.POD && contratto.POD.length > 1 && contratto.DATA_PROSSIMA_LIQUIDAZIONE && isLiquidato(contratto)"
                              class="badge bg-success">
                            <i class="fas fa-check"></i> Liquidato fino al {{ filters.formatDate(contratto.DATA_PROSSIMA_LIQUIDAZIONE) }}
                        </span>
                        <span v-else-if="contratto.POD && contratto.POD.length > 1 && contratto.DATA_ULTIMA_LIQUIDAZIONE && isInScadenza(contratto)"
                              class="badge bg-warning">
                            <i class="fas fa-exclamation-triangle"></i> In scadenza
                        </span>
                        <span v-else-if="contratto.POD && contratto.POD.length > 1 && !contratto.DATA_ULTIMA_LIQUIDAZIONE"
                              class="badge bg-danger">
                            <i class="fas fa-times"></i> Mai liquidato
                        </span>
                        <span v-else-if="contratto.POD && contratto.POD.length > 1"
                              class="badge bg-danger">
                            <i class="fas fa-times"></i> Da liquidare
                        </span>
                    </td>
                    <td style="width:6%" class="text-center">
                        <button class="btn btn-warning btn-sm" @click="modificaContratto(contratto)"
                            title="Modifica il contratto">
                            <i class="fal fa-pen"></i>
                        </button>
                        <button class="btn btn-danger btn-sm ml-1" @click="eliminaContratto(contratto)"
                            title="Elimina il contratto">
                            <i class="fal fa-trash"></i>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
        <div v-if="$root.isMobile" class="row justify-content-center">
            <div class="col-12 mb-4" v-for="contratto in paginatedList.arr" :key="contratto.ID_CONTRATTO">
                <div class="card shadow border-0 text-center p-3" style="border-radius: 20px;">
                    <div class="card-body">
                        <i class="fad fa-file-contract fa-6x mb-4"></i>
                        <div class="font-weight-bold text-ecomm h4 mb-3">
                            Contratto #{{ contratto.CODICE_CONTRATTO }}
                        </div>

                        <div>
                            <p><strong>Agente:</strong> {{ contratto.DESCRIZIONE_AGENTE || 'Non disponibile' }}</p>
                            <p><strong>Cliente:</strong> {{ contratto.DENOMINAZIONE || 'Non disponibile' }}</p>
                            <p><strong>Tipo:</strong>
                                <span v-if="contratto.POD">
                                    POD: {{ contratto.POD }}
                                </span>
                                <span v-else-if="contratto.PDR">
                                    PDR: {{ contratto.PDR }}
                                </span>
                            </p>
                        </div>
                        <div>
                            <p><strong>Data Inizio Fornitura:</strong> {{
                                filters.formatDate(contratto.DATA_INIZIO_FORNITURA) == 'Invalid date' ? '—' :
                                    filters.formatDate(contratto.DATA_INIZIO_FORNITURA) }}</p>
                            <p><strong>Data Fine Fornitura:</strong> {{
                                filters.formatDate(contratto.DATA_FINE_FORNITURA)
                                    == 'Invalid date' ? '—' : filters.formatDate(contratto.DATA_FINE_FORNITURA)}}</p>
                        </div>
                        <div>
                            <p><strong>Gettone Contratto:</strong> {{ contratto.GETTONE_CONTRATTO }}€</p>
                        </div>
                        <div>
                            <p><strong>Stato:</strong>
                                <span :class="getStatoBadgeClass(contratto.FLG_ATTIVO)">
                                    {{ getStatoLabel(contratto.FLG_ATTIVO) }}
                                </span>
                            </p>
                        </div>

                        <!-- Stato Liquidazione - Solo per POD -->
                        <div v-if="contratto.POD && contratto.POD.length > 1" class="mt-3">
                            <p><strong>Stato Liquidazione:</strong></p>
                            <span v-if="contratto.DATA_PROSSIMA_LIQUIDAZIONE && isLiquidato(contratto)"
                                  class="badge bg-success">
                                <i class="fas fa-check"></i> Liquidato fino al {{ filters.formatDate(contratto.DATA_PROSSIMA_LIQUIDAZIONE) }}
                            </span>
                            <span v-else-if="contratto.DATA_ULTIMA_LIQUIDAZIONE && isInScadenza(contratto)"
                                  class="badge bg-warning">
                                <i class="fas fa-exclamation-triangle"></i> In scadenza
                            </span>
                            <span v-else-if="!contratto.DATA_ULTIMA_LIQUIDAZIONE"
                                  class="badge bg-danger">
                                <i class="fas fa-times"></i> Mai liquidato
                            </span>
                            <span v-else
                                  class="badge bg-danger">
                                <i class="fas fa-times"></i> Da liquidare
                            </span>
                        </div>

                        <div class="d-flex justify-content-center mt-3">
                            <button class="btn btn-warning btn-sm" @click="modificaContratto(contratto)"
                                title="Modifica il contratto">
                                <i class="fal fa-pen"></i>
                            </button>
                            <button class="btn btn-danger btn-sm ml-1" @click="eliminaContratto(contratto)"
                                title="Elimina il contratto">
                                <i class="fal fa-trash"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Pagine v-model="search.PAGINATION.PAGE_NUMBER" :numrighe="paginatedList.count"
            :numpagine="search.PAGINATION.LENGTH">
        </Pagine>
    </div>

    <div class="modal fade" id="popUpContratto" data-backdrop="true" role="dialog" aria-modal="true">
        <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
            <div class="modal-content">
                <div class="modal-header text-white"
                    style="background:  linear-gradient(135deg, #808000, #D9CB34); color: #fff;">

                    <h5 class="modal-title" id="modaleContrattoLabel"><i class="fal fa-file-invoice-dollar fa-fw"
                            style="color:#fff"></i> Modifica Contratto</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-6">
                            <label for="">Gettone Contratto</label>
                            <div class="input-group">
                                <input type="text" class="form-control" placeholder="Modifica Gettone"
                                    v-model="contrattoSelezionato.GETTONE_CONTRATTO">
                                <span class="input-group-text">€</span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label for="">Stato Contratto</label>
                            <select class="form-control" v-model="contrattoSelezionato.FLG_ATTIVO">
                                <option :value="1">Attivo</option>
                                <option :value="2">Chiuso da fatturare</option>
                                <option :value="3">Attivo da fatturare</option>
                                <option :value="4">In attivazione</option>
                                <option :value="5">Disattivo</option>
                            </select>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-md-4">
                            <label for="">Data Inizio Fornitura</label>
                            <div class="input-group">
                                <DatePicker placeholder="data" autocomplete="off" :dim="'md'" type="text"
                                     v-model="contrattoSelezionato.DATA_INIZIO_FORNITURA">
                                </DatePicker>
                                  <span class="input-group-text"><i class="fas fa-calendar"></i></span>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <label for="">Data Fine Fornitura</label>
                            <div class="input-group">
                                <DatePicker placeholder="data" autocomplete="off" :dim="'md'" type="text"
                                     v-model="contrattoSelezionato.DATA_FINE_FORNITURA">
                                </DatePicker>
                                   <span class="input-group-text"><i class="fas fa-calendar"></i></span>
                            </div>
                        </div>
                        <div class="col-md-4">
                             <label for="">Agente</label>
                             <Select2 v-model="contrattoSelezionato.FK_ID_AGENTE" :w="150"
                                :api="'dcp/agente/select2?a=1'" :apiselected="'dcp/agente/s2'">
                            </Select2>
                        </div>
                         
                    </div>
                    <div class="row mt-3">
                        <div v-show="contrattoSelezionato.DATA_ULTIMA_LIQUIDAZIONE != null" class="col-md-4">
                            <label for="">Data Ultima Liquidazione</label>
                            <div class="input-group">
                                <input type="text" class="form-control"
                                       :value="filters.formatDate(contrattoSelezionato.DATA_ULTIMA_LIQUIDAZIONE)"
                                       disabled
                                       style="background-color: #e9ecef;">
                                <span class="input-group-text"><i class="fas fa-lock text-muted"></i></span>
                            </div>
                        </div>
                        <div v-show="contrattoSelezionato.DATA_PROSSIMA_LIQUIDAZIONE != null"  class="col-md-4">
                            <label for="">Data Prossima Liquidazione</label>
                            <div class="input-group">
                                <DatePicker placeholder="data" autocomplete="off" :dim="'md'" type="text"
                                        v-model="contrattoSelezionato.DATA_PROSSIMA_LIQUIDAZIONE">
                                </DatePicker>
                                <span class="input-group-text"><i class="fas fa-calendar"></i></span>
                            </div>
                        </div>
                    </div>

                    <!-- Data Prossima Liquidazione - solo per POD liquidati -->
                   
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal"><i class="fas fa-times"></i>
                        Chiudi</button>
                    <button class="btn btn-success float-right" v-on:click="salvaContratto()"><i
                            class="fa fa-check"></i>
                        Salva</button>
                </div>
            </div>
        </div>
    </div>





</template>
<script>

import Pagine from '@/components/utils/Pagine.vue'
import DatePicker from '@/components/utils/DatePicker.vue'
import Select2 from '@/components/utils/Select2.vue'



export default {
    name: "Contratti",
    components: {
        Pagine,
        DatePicker,
        Select2,
    },
    data: function () {
        return {
            filters: global.filters,
            search: {
                PAGINATION: { LENGTH: 0, PAGE_NUMBER: 1, PAGE_SIZE: 50 },
                FK_ID_CLIENTE: { TYPE: 'TEXT', VALUE: '' },
                FK_ID_TIPO: { TYPE: 'COMBO', VALUE: '' },
                DENOMINAZIONE: { TYPE: 'TEXT', VALUE: '' },
                DATA_INIZIO_FORNITURA: { TYPE: 'DATE_RANGE', VALUE_FROM: '' },
                DATA_FINE_FORNITURA: { TYPE: 'DATE_RANGE', VALUE_TO: '' },
                DESCRIZIONE_AGENTE: { TYPE: 'TEXT', VALUE: '' },
                CODICE_CONTRATTO: { TYPE: 'TEXT', VALUE: '' },
                POD: { TYPE: 'TEXT', VALUE: '' },
                PDR: { TYPE: 'TEXT', VALUE: '' },
                FLG_ATTIVO: { TYPE: 'COMBO', VALUE: '' },
                STATO_LIQUIDAZIONE: { TYPE: 'COMBO', VALUE: '' },
                DATA_ELABORAZIONE: { TYPE: 'DATE', VALUE: '' },
            },
            arrayContratti: new Array(),
            contrattoSelezionato: {},
            infoSelezionata: {},
            showFilters: false,
        }
    },
    methods: {
        modificaContratto: function (contratto) {
            // Verifica se è liquidato PRIMA di clonare e formattare
            const isPOD = contratto.POD && contratto.POD.length > 1;
            const dataLiquidazione = contratto.DATA_PROSSIMA_LIQUIDAZIONE;
            let isLiquidato = false;

            if (isPOD && dataLiquidazione && dataLiquidazione !== '0000-00-00' && dataLiquidazione !== null) {
                const prossima = new Date(dataLiquidazione).getTime();
                const oggi = new Date().getTime();
                isLiquidato = prossima > oggi;
            }

            this.contrattoSelezionato = utils.clone(contratto);

            // Salva il flag liquidato per usarlo nella computed property
            this.contrattoSelezionato._IS_LIQUIDATO = isLiquidato;

            // Ora formatta le date per il display
            this.contrattoSelezionato.DATA_INIZIO_FORNITURA = this.filters.formatDate(this.contrattoSelezionato.DATA_INIZIO_FORNITURA);
            this.contrattoSelezionato.DATA_PROSSIMA_LIQUIDAZIONE = this.filters.formatDate(this.contrattoSelezionato.DATA_PROSSIMA_LIQUIDAZIONE);

            // Se DATA_FINE_FORNITURA è null, '1901-01-01' o '0000-00-00', lascia il campo vuoto
            if (this.contrattoSelezionato.DATA_FINE_FORNITURA == null ||
                this.contrattoSelezionato.DATA_FINE_FORNITURA == '1901-01-01' ||
                this.contrattoSelezionato.DATA_FINE_FORNITURA == '0000-00-00' ||
                this.filters.formatDate(this.contrattoSelezionato.DATA_FINE_FORNITURA) == '01/01/1901') {
                this.contrattoSelezionato.DATA_FINE_FORNITURA = '';
            } else {
                this.contrattoSelezionato.DATA_FINE_FORNITURA = this.filters.formatDate(this.contrattoSelezionato.DATA_FINE_FORNITURA);
            }

            // Usa $nextTick per assicurarsi che il DOM si aggiorni dopo l'assegnazione di _IS_LIQUIDATO
            this.$nextTick(() => {
                utils.openModal('popUpContratto');
            });
        },
        moreInfo: function (idContratto) {
            var modal = utils.openModal('popUpInfo');
            global.utils.get('/dcp/contratto/info', { ID_CONTRATTO: idContratto }, (response) => {
                if (response.esito == 0) {
                    this.infoSelezionata = response.data
                    utils.alert.success(response.messaggio);
                }
            });
        },
        getContratti: function () {
            global.utils.get('/dcp/contratti', {}, (response) => {
                this.arrayContratti = response.data;
            });
        },
        eliminaContratto: function (contratto) {
            utils.alert.confirm('Sei sicuro di voler eliminare il contratto selezionato? Verranno rimosse anche le liquidazioni associate e aggiornati i pagamenti collegati.', () => {
                global.utils.delete('/dcp/contratto', { ID_CONTRATTO: contratto.ID_CONTRATTO }, (response) => {
                    if (response.esito == 0) {
                        utils.alert.success(response.messaggio);
                        this.getContratti();
                    }
                });
            }, this.$root);
        },
        salvaContratto: function () {
            // Validazione: se lo stato è "Chiuso da fatturare" (2) o "Disattivo" (5),
            // la DATA_FINE_FORNITURA è obbligatoria
            if ((this.contrattoSelezionato.FLG_ATTIVO == 2 || this.contrattoSelezionato.FLG_ATTIVO == 5)) {
                if (!this.contrattoSelezionato.DATA_FINE_FORNITURA ||
                    this.contrattoSelezionato.DATA_FINE_FORNITURA === '' ||
                    this.contrattoSelezionato.DATA_FINE_FORNITURA === '1901-01-01' ||
                    this.contrattoSelezionato.DATA_FINE_FORNITURA === '0000-00-00') {
                    utils.alert.warning('Per i contratti in stato "Chiuso da fatturare" o "Disattivo" è obbligatorio inserire la Data Fine Fornitura');
                    return;
                }
            }
            this.contrattoSelezionato.DATA_PROSSIMA_LIQUIDAZIONE = this.filters.formatDateReverse(this.contrattoSelezionato.DATA_PROSSIMA_LIQUIDAZIONE);
            this.contrattoSelezionato.DATA_INIZIO_FORNITURA = this.filters.formatDateReverse(this.contrattoSelezionato.DATA_INIZIO_FORNITURA);
            this.contrattoSelezionato.DATA_FINE_FORNITURA = this.filters.formatDateReverse(this.contrattoSelezionato.DATA_FINE_FORNITURA);

            global.utils.put('/dcp/contratto', this.contrattoSelezionato, (response) => {
                if (response.esito == 0) {
                    this.getContratti();
                    var modal = utils.closeModal('popUpContratto')
                    utils.alert.success(response.messaggio);
                }
            });
        },
        getStatoLabel: function (flgAttivo) {
            // Mappa il valore numerico al testo dello stato
            switch (flgAttivo) {
                case 1: return 'Attivo';
                case 2: return 'Chiuso da fatturare';
                case 3: return 'Attivo da fatturare';
                case 4: return 'In attivazione';
                case 5: return 'Disattivo';
                default: return 'Sconosciuto';
            }
        },
        getStatoBadgeClass: function (flgAttivo) {
            // Mappa il valore numerico alla classe badge
            switch (flgAttivo) {
                case 1: return 'badge bg-success text-white'; // Attivo - verde
                case 2: return 'badge bg-warning text-white'; // Chiuso da fatturare - giallo
                case 3: return 'badge bg-info text-white'; // Attivo da fatturare - azzurro
                case 4: return 'badge bg-primary text-white'; // In attivazione - blu
                case 5: return 'badge bg-danger text-white'; // Disattivo - rosso
                default: return 'badge bg-secondary text-white'; // Sconosciuto - grigio
            }
        },
        isLiquidato: function (contratto) {
            if (!contratto) return false;

            // Verifica se è un POD
            if (!contratto.POD || contratto.POD.length <= 1) return false;

            // Usa la data originale (non formattata) se disponibile, altrimenti usa quella normale
            const dataLiquidazione = contratto.DATA_PROSSIMA_LIQUIDAZIONE_ORIGINALE || contratto.DATA_PROSSIMA_LIQUIDAZIONE;

            if (!dataLiquidazione || dataLiquidazione === '0000-00-00' || dataLiquidazione === null) return false;

            const prossima = new Date(dataLiquidazione).getTime();
            const oggi = new Date().getTime();

            console.log('Contratto POD:', contratto.POD);
            console.log('Data usata per confronto:', dataLiquidazione);
            console.log('Timestamp prossima:', prossima);
            console.log('Timestamp oggi:', oggi);
            console.log('È liquidato?', prossima > oggi);

            return prossima > oggi;
        },
        isInScadenza: function (contratto) {
            if (!contratto.DATA_PROSSIMA_LIQUIDAZIONE) return false;
            const prossima = new Date(contratto.DATA_PROSSIMA_LIQUIDAZIONE);
            const oggi = new Date();
            const diffTime = prossima - oggi;
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            return diffDays > 0 && diffDays <= 30; // In scadenza negli ultimi 30 giorni
        },
        giorniRimanenti: function (contratto) {
            if (!contratto.DATA_PROSSIMA_LIQUIDAZIONE) return 0;
            const prossima = new Date(contratto.DATA_PROSSIMA_LIQUIDAZIONE);
            const oggi = new Date();
            const diffTime = prossima - oggi;
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            return diffDays > 0 ? diffDays : 0;
        },
    },
    computed: {
        paginatedList() {
            let contratti = this.arrayContratti;

            // Se viene filtrato per DESCRIZIONE_AGENTE, escludi i contratti con agente null
            if (this.search.DESCRIZIONE_AGENTE.VALUE && this.search.DESCRIZIONE_AGENTE.VALUE.trim() !== '') {
                contratti = contratti.filter(c =>
                    c.DESCRIZIONE_AGENTE != null &&
                    c.DESCRIZIONE_AGENTE != undefined &&
                    c.DESCRIZIONE_AGENTE !== ''
                );
            }

            // Filtro per stato liquidazione (solo per POD)
            if (this.search.STATO_LIQUIDAZIONE.VALUE && this.search.STATO_LIQUIDAZIONE.VALUE !== '') {
                const statoLiq = this.search.STATO_LIQUIDAZIONE.VALUE;
                contratti = contratti.filter(c => {
                    // Il filtro mostra SOLO i contratti POD che rispettano il criterio
                    if (!c.POD || c.POD.length <= 1) {
                        return false; // Escludi i contratti PDR quando il filtro è attivo
                    }

                    switch (statoLiq) {
                        case 'liquidato':
                            return c.DATA_PROSSIMA_LIQUIDAZIONE && this.isLiquidato(c);
                        case 'in_scadenza':
                            return c.DATA_ULTIMA_LIQUIDAZIONE && this.isInScadenza(c);
                        case 'mai_liquidato':
                            return !c.DATA_ULTIMA_LIQUIDAZIONE;
                        case 'da_liquidare':
                            return c.DATA_ULTIMA_LIQUIDAZIONE && !this.isLiquidato(c) && !this.isInScadenza(c);
                        default:
                            return true;
                    }
                });
            }
            

            var arr = utils.inGrid(contratti, this.search);
            return arr;
        }
    },

    created: function () {
        this.getContratti();
    }
}
</script>

<style scoped>
.mobile-page-title {
    padding: 15px;
    background: linear-gradient(135deg, #808000, #D9CB34);
    color: white;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    position: sticky;
    top: 0;
    z-index: 100;
}

.mobile-page-title h4 {
    margin: 0;
    color: white;
}

.mobile-page-title i {
    margin-right: 8px;
}

/* Nascondi il portlet head in mobile visto che è vuoto */
@media (max-width: 767px) {
    .kt-portlet__head {
        height: 0 !important;
        overflow: hidden;
    }
}

/* Quando la larghezza della finestra è maggiore o uguale a 1536 */
@media (min-width: 1282px) {
    .isprint-grid-container {
        margin-top: 20px;
        width: auto;
        table-layout: auto;
    }
}

/* Tablet - tra 768px e 1281px */
@media (min-width: 768px) and (max-width: 1281px) {
    .isprint-grid-container {
        margin-top: 100px;
    }
}

/* Mobile - inferiore a 768px */
@media (max-width: 767px) {
    .isprint-grid-container {
        margin-top: 20px;
    }
}
</style>